module.exports = __webpack_public_path__ + "static/img/3.984f3ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/3.jpg
// module id = 9rDa
// module chunks = 1